import { DateTime } from 'luxon';

interface DateTableCellProps {
    value?: any;
    format: string;
}

export const DateTableCell = ({ value, format }: DateTableCellProps) => {
    return DateTime.fromSeconds(value).toFormat(format);
};
